import { AlertMessage } from "../components/alert-message";
import { notification } from "antd";

notification.config({
  maxCount: 1,
});

export type AlertAutoClosingProps = AlertMessage & {
  className?: string | null;
  duration?: number | null;
};

export const showAutoClosingAlert = (autoClosingAlertProps: AlertAutoClosingProps | undefined) => {
  if (autoClosingAlertProps === undefined) {
    return;
  }

  const { className, duration, ...alertMessage } = autoClosingAlertProps;

  const { type } = alertMessage;
  notification[type]({
    duration: duration ?? 1.2,
    message: alertMessage.message,
    description: alertMessage.description,
    ...(className ? { className } : {}),
  });
};
